import SignUpAdditionalDetails from './sign_up_additional_details_modal';
export default SignUpAdditionalDetails;
